<template>
  <div class="main">
    <div class="main_top">
      <el-select
        v-model="roleid"
        @change="roleChange"
        placeholder="请选择角色"
        clearable
      >
        <el-option
          v-for="role in roleList"
          :key="role.roleid"
          :label="role.rolename"
          :value="role.roleid"
        ></el-option>
      </el-select>
      <el-select
        v-model="specid"
        @change="majorChange"
        placeholder="请选择专业"
        clearable
      >
        <el-option
          v-for="item in majorList"
          :key="item.orgid"
          :label="item.orgname"
          :value="item.orgid"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="selectclass"
        placeholder="请选择查询班级"
        @change="selectclassChange"
        clearable
      >
        <el-option
          v-for="item in classList"
          :key="item.orgid"
          :label="item.orgname"
          :value="item.orgid"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="classData"
        multiple
        placeholder="请选择所要添加班级"
        @change="classChange"
      >
        <el-option
          v-for="item in classList"
          :key="item.orgid"
          :label="item.orgname"
          :value="item.orgid"
        >
        </el-option>
      </el-select>

      <el-button
        type="primary"
        style="float: right; margin-right: 100px"
        @click="SaveExperAuthData"
        >保存权限</el-button
      >
    </div>
    <div class="main_body">
      <el-tree
        :data="expDataList"
        show-checkbox
        accordion
        node-key="itemid"
        ref="expRef"
        :default-checked-keys="defaultChecked"
        :props="defaultProps"
        @check-change="handleCheckChange"
      >
      </el-tree>
    </div>
  </div>
</template>
<script>
import Api from "../../api/index";

export default {
  data() {
    return {
      roleid: "",
      specid: "",
      roleList: [],
      majorList: [],
      classData: [],
      classList: [],
      selectclass: "",
      expDataList: [],
      defaultChecked: [], //权限默认选中
      expitem: {}, //角色选中项
      defaultProps: {
        label: "itemname",
        children: "children",
      },
    };
  },

  created() {
    this.GetspecialtynList();
    this.GetDataList();
    this.getRoleList();
  },

  methods: {
    //专业列表
    async GetspecialtynList() {
      const res = await Api.organization.GetspecialtynList();
      if (res.success != true) return this.$Message.info(res.msg);
      this.majorList = res.rows;
    },
    //获取角色列表
    async getRoleList() {
      const res = await Api.role.GetDataList(1, 1000);
      if (res.success) {
        res.rows.forEach((r) => {
          if (r.roletype == 5 || r.roletype == 6) this.roleList.push(r);
        });
      }
    },
    //获取权限列表
    async GetDataList() {
      const res = await Api.exp.GetExperAuthDataTree();
      if (res.success != true) return this.$Message.info(res.msg);
      this.expDataList = res.rows.experdata;
    },

    async roleChange(val) {
      const res = await Api.exp.GetExperAuthDataTree(
        val,
        this.specid,
        this.selectclass
      );
      if (res.success != true) return this.$Message.info(res.msg);
      this.expDataList = res.rows.experdata;
      this.defaultChecked = res.rows.checkexper;
    },

    async majorChange(val) {
      const res = await Api.exp.GetExperAuthDataTree(
        this.roleid,
        val,
        this.selectclass
      );
      if (res.success != true) return this.$Message.info(res.msg);
      this.expDataList = res.rows.experdata;
      this.defaultChecked = res.rows.checkexper;

      this.classData = [];
      this.selectclass = "";
      const req = await Api.organization.GetClassList(val);
      if (req.success != true) return this.$Message.info(req.msg);
      this.classList = req.rows;
    },

    async selectclassChange(val) {
      const res = await Api.exp.GetExperAuthDataTree(
        this.roleid,
        this.specid,
        val
      );
      if (res.success != true) return this.$Message.info(res.msg);
      this.expDataList = res.rows.experdata;
      this.defaultChecked = res.rows.checkexper;
    },

    classChange(val) {
      console.log(val);
    },

    handleCheckChange(data, checked) {
      if (checked) {
        data.ischeck = checked;
      }
    },

    async SaveExperAuthData() {
      const params = {};
      params.roleid = this.roleid;
      params.classids = this.classData;
      params.specid = this.specid;
      params.experids = this.$refs.expRef.getCheckedKeys();
      const res = await Api.exp.SaveExperAuthData(params);
      if (res.success != true) return this.$Message.info(res.msg);
      this.$Message.success(res.msg);
    },
  },
};
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .main_top {
    height: 60px;
    padding: 20px 15px 0 20px;
    > div {
      margin-right: 20px;
    }
    /deep/.el-select__tags {
      > span {
        display: block;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  .main_body {
    > div {
      margin-left: 50px;
      margin-top: 20px;
    }
  }
}
</style>